<!-- gif-search.component.html -->
<ion-header>
  <ion-toolbar>
    <ion-title>GIF Search</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()"><ion-icon name="close-outline"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-searchbar #searchbar
    [(ngModel)]="searchTerm"
    (ionInput)="searchTerm$.next(searchTerm)"
    placeholder="Search GIFs">
  </ion-searchbar>
  <ion-grid *ngIf="gifs.length > 0" class="pb">
    <ion-row>
      <ion-col size="6" size-md="4" size-lg="3" *ngFor="let gif of gifs">
        <ion-card class="m0" (click)="selectGif(gif.images.original.url)">
          <img [src]="gif.images.fixed_height_small.url" [alt]="gif.title" />
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-infinite-scroll (ionInfinite)="loadMoreGifs($event)">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="Loading more GIFs...">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>

